import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InsightsUtility } from '../utilities/insights/insights.utility';

@Injectable()
export class ContextInterceptor implements HttpInterceptor {
	constructor(private insightsUtility: InsightsUtility) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const clonedRequest = request.clone({ headers: request.headers.append('context', JSON.stringify(this.insightsUtility.context)) });
		return next.handle(clonedRequest);
	}
}
